<template>
  <div>
    <div class="mb-8 flex justify-between w-full">
      <h1 class="font-bold text-3xl">
        <inertia-link
          class="kreditgenie-text-green hover:kreditgenie-text-green-hover"
          :href="route('clients')"
        >
          Kunde
        </inertia-link>
        <span class="kreditgenie-text-green font-medium">/</span>
        Erschaffen
      </h1>
      <h1 class="font-bold text-3xl align-right">{{ form.user }}</h1>
    </div>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-full">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <div class="w-full">
            <div class="bg-white">
              <nav class="tabs flex flex-col sm:flex-row">
                <button
                  v-for="(tab, index) in tabs"
                  :key="tab"
                  data-target="panel-2"
                  class="tab ext-gray-600 py-4 px-6 block hover:text-blue-500 focus:outline-none"
                  :class="index === selectedTab ? 'active-tab' : ''"
                  @click.prevent="showTab(index)"
                >
                  {{ tab }}
                </button>
              </nav>
            </div>
            <div id="panels">
              <div
                v-show="selectedTab === 0"
                class="panel-1 tab-content py-5"
              >
                <text-input
                  v-model="form.first_name"
                  :error="form.errors.first_name"
                  class="pr-6 pb-8 w-full"
                  label="Vorname"
                />
                <text-input
                  v-model="form.last_name"
                  :error="form.errors.last_name"
                  class="pr-6 pb-8 w-full"
                  label="Nachname"
                />
                <text-input
                  v-model="form.email"
                  :error="form.errors.email"
                  class="pr-6 pb-8 w-full"
                  label="Email"
                />
                <text-input
                  v-model="form.phone"
                  :error="form.errors.phone"
                  class="pr-6 pb-8 w-full"
                  label="Telefon"
                />
                <text-input
                  v-model="form.address"
                  :error="form.errors.address"
                  class="pr-6 pb-8 w-full"
                  label="Adresse"
                />
                <text-input
                  v-model="form.lives_here_from"
                  :error="form.errors.lives_here_from"
                  class="pr-6 pb-8 w-full"
                  label="Lebt hier ab"
                />
                <text-input
                  v-model="form.zip_code"
                  :error="form.errors.zip_code"
                  class="pr-6 pb-8 w-full"
                  label="Postleitzahl"
                />
                <text-input
                  v-model="form.city"
                  :error="form.errors.city"
                  class="pr-6 pb-8 w-full"
                  label="Stadt"
                />
                <text-input
                  v-model="form.country"
                  :error="form.errors.country"
                  class="pr-6 pb-8 w-full"
                  label="Land"
                />
                <text-input
                  v-model="form.citizenship"
                  :error="form.errors.citizenship"
                  class="pr-6 pb-8 w-full"
                  label="Staatsangehörigkeit"
                />
                <text-input
                  v-model="form.place_of_birth"
                  :error="form.errors.place_of_birth"
                  class="pr-6 pb-8 w-full"
                  label="Geburtsort"
                />
                <select-input
                  v-model="form.gender"
                  :error="form.errors.gender"
                  class="pr-6 pb-8 w-full"
                  label="Anrede"
                >
                  <option :key="`Herr`" :value="`Herr`">
                    Herr
                  </option>
                  <option :key="`Frau`" :value="`Frau`">
                    Frau
                  </option>
                </select-input>
                <text-input
                  v-model="form.date_of_birth"
                  :error="form.errors.date_of_birth"
                  class="pr-6 pb-8 w-full"
                  label="Geburtsdatum"
                />
                <select-input
                  v-model="form.family_status"
                  :error="form.errors.family_status"
                  class="pr-6 pb-8 w-full"
                  label="Familienstand"
                >
                  <option :key="`Ledig`" :value="`Ledig`">
                    Ledig
                  </option>
                  <option :key="`Verheiratet`" :value="`Verheiratet`">
                    Verheiratet
                  </option>
                  <option :key="`Geschieden`" :value="`Geschieden`">
                    Geschieden
                  </option>
                  <option :key="`Getrennt lebend`" :value="`Getrennt lebend`">
                    Getrennt lebend
                  </option>
                  <option :key="`Verwitwet`" :value="`Verwitwet`">
                    Verwitwet
                  </option>
                  <option :key="`Verpartnert`" :value="`Verpartnert`">
                    Verpartnert
                  </option>
                </select-input>
                <text-input
                  v-model="form.work_permit_type"
                  :error="form.errors.work_permit_type"
                  class="pr-6 pb-8 w-full"
                  label="Art der Aufenthaltserlaubnis"
                />
                <text-input
                  v-model="form.number_of_kids_with_benefit"
                  :error="form.errors.number_of_kids_with_benefit"
                  class="pr-6 pb-8 w-full"
                  label="Anzahl der Kinder mit Leistungen"
                />
                <select-input
                  v-model="form.user_id" label="Adviser"
                  :error="form.errors.user_id"
                  class="pr-6 pb-8 w-full"
                >
                  <option v-for="user in users" :key="user.id" :value="user.id">
                    {{ user.first_name + ' ' + user.last_name }} {{ user.user_function ? '(' + user.user_function + ')' : '' }}
                  </option>
                </select-input>
              </div>
              <div
                v-show="selectedTab === 1"
                class="panel-2 tab-content py-5"
              >
                <text-input
                  v-model="form.occupation"
                  :error="form.errors.occupation"
                  class="pr-6 pb-8 w-full"
                  label="Beruf"
                />
                <text-input
                  v-model="form.company"
                  :error="form.errors.company"
                  class="pr-6 pb-8 w-full"
                  label="Firma"
                />
                <text-input
                  v-model="form.started_working_at"
                  :error="form.errors.started_working_at"
                  class="pr-6 pb-8 w-full"
                  label="Eintrittsdatum"
                />
                <text-input
                  v-model="form.employment_type"
                  :error="form.errors.employment_type"
                  class="pr-6 pb-8 w-full"
                  label="Beschäftigungsverhältnis"
                />
                <select-input
                  v-model="form.is_probation_period"
                  :error="form.errors.status"
                  class="pr-6 pb-8 w-full"
                  label="Probezeit"
                >
                  <option :key="1" :value="1">
                    Ja
                  </option>
                  <option :key="0" :value="0">
                    Nein
                  </option>
                </select-input>
                <text-input
                  v-model="form.probation_period_until"
                  :error="form.errors.probation_period_until"
                  class="pr-6 pb-8 w-full"
                  label="Probezeit bis"
                />
                <text-input
                  v-model="form.number_of_salaries"
                  :error="form.errors.number_of_salaries"
                  class="pr-6 pb-8 w-full"
                  label="Anzahl der Gehälter"
                />
                <text-input
                  v-model="form.average_monthly_income"
                  :error="form.errors.average_monthly_income"
                  class="pr-6 pb-8 w-full"
                  label="Durchschnittliches monatliches Einkommen"
                />
                <text-input
                  v-model="form.other_income"
                  :error="form.errors.other_income"
                  class="pr-6 pb-8 w-full"
                  label="Anderes Einkommen"
                />
                <text-input
                  v-model="form.other_income_source"
                  :error="form.errors.other_income_source"
                  class="pr-6 pb-8 w-full"
                  label="Andere Einnahmequelle"
                />
              </div>
              <div
                v-show="selectedTab === 2"
                class="panel-3 tab-content py-5"
              >
                <text-input
                  v-model="form.number_of_credits"
                  :error="form.errors.number_of_credits"
                  class="pr-6 pb-8 w-full"
                  label="Anzahl der Kredite"
                />
                <select-input
                  v-model="form.has_rent"
                  :error="form.errors.status"
                  class="pr-6 pb-8 w-full"
                  label="Hat Miete?"
                >
                  <option :key="1" :value="1">
                    Ja
                  </option>
                  <option :key="0" :value="0">
                    Nein
                  </option>
                </select-input>
                <text-input
                  v-model="form.rent_amount"
                  :error="form.errors.rent_amount"
                  class="pr-6 pb-8 w-full"
                  label="Mietbetrag"
                />
                <select-input
                  v-model="form.has_furniture_expenses"
                  :error="form.errors.status"
                  class="pr-6 pb-8 w-full"
                  label="Eigentum?"
                >
                  <option :key="1" :value="1">
                    Ja
                  </option>
                  <option :key="0" :value="0">
                    Nein
                  </option>
                </select-input>
                <text-input
                  v-model="form.furniture_expenses_rate"
                  :error="form.errors.furniture_expenses_rate"
                  class="pr-6 pb-8 w-full"
                  label="Finanzierungrate"
                />
                <select-input
                  v-model="form.has_leasing"
                  :error="form.errors.status"
                  class="pr-6 pb-8 w-full"
                  label="Hat Leasing?"
                >
                  <option :key="1" :value="1">
                    Ja
                  </option>
                  <option :key="0" :value="0">
                    Nein
                  </option>
                </select-input>
                <text-input
                  v-model="form.leasing_rate"
                  :error="form.errors.leasing_rate"
                  class="pr-6 pb-8 w-full"
                  label="Leasingrate"
                />
                <text-input
                  v-model="form.iban"
                  :error="form.errors.iban"
                  class="pr-6 pb-8 w-full"
                  label="IBAN"
                />
              </div>
              <div v-show="selectedTab === 3" class="panel-3 tab-content py-5">
                <select-input
                  v-model="form.type"
                  :error="form.errors.type"
                  class="pr-6 pb-8 w-full"
                  label="Kreditart"
                >
                  <option value="private_credit">Privatkredit</option>
                  <option value="property_credit">Immobilienkredit</option>
                </select-input>
                <select-input
                  v-model="form.credit_purpose"
                  :error="form.errors.credit_purpose"
                  class="pr-6 pb-8 w-full"
                  label="Kreditzweck"
                >
                  <option :key="`Einkauf-Konsum`" :value="`Einkauf-Konsum`">
                    Einkauf/Konsum
                  </option>
                  <option :key="`Freie Verwendung`" :value="`Freie Verwendung`">
                    Freie Verwendung
                  </option>
                  <option :key="`Reisen`" :value="`Reisen`">
                    Reisen
                  </option>
                  <option :key="`Rechnungsausgleich`" :value="`Rechnungsausgleich`">
                    Rechnungsausgleich
                  </option>
                  <option :key="`Fahrzeugkauf`" :value="`Fahrzeugkauf`">
                    Fahrzeugkauf
                  </option>
                  <option :key="`Ausbildung-Studium`" :value="`Ausbildung-Studium`">
                    Ausbildung/Studium
                  </option>
                  <option :key="`Umschuldung`" :value="`Umschuldung`">
                    Umschuldung
                  </option>
                  <option :key="`Modernisierung`" :value="`Modernisierung`">
                    Modernisierung
                  </option>
                  <option :key="`Kredit bei negativem Schufaeintrag`" :value="`Kredit bei negativem Schufaeintrag`">
                    Kredit bei negativem Schufaeintrag
                  </option>
                </select-input>
                <text-input
                  v-model="form.wanted_credit_amount"
                  :error="form.errors.wanted_credit_amount"
                  class="pr-6 pb-8 w-full"
                  label="Gewünschter Kreditbetrag"
                />
                <text-input
                  v-model="form.period"
                  :error="form.errors.period"
                  class="pr-6 pb-8 w-full"
                  label="Zeitraum (in Monaten)"
                />
                <div class="pb-8 w-full">
                  Kreditsicherung:
                </div>
                <div class="flex justify-evenly">
                  <checkbox-input
                    v-model="caseOfDeath"
                    label="Bei Todesfall"
                    @input="handleSecuring('Abs. bei Todesfall')"
                  />
                  <checkbox-input
                    v-model="caseOfUnemployability"
                    label="Bei Arbeitsunfähigkeit"
                    @input="handleSecuring('Abs. bei AU')"
                  />
                  <checkbox-input
                    v-model="caseOfLoosingJob"
                    label="Bei Arbeitslosigkeit"
                    @input="handleSecuring('Abs. bei AL')"
                  />
                </div>
              </div>
              <div v-show="selectedTab === 4" class="panel-3 tab-content py-5">
                <table class="w-full border-collapse mb-5 mr-5">
                  <tr>
                    <td class="
                        px-2
                        bg-blueGray-50
                        text-blueGray-500
                        border border-solid
                        border-blueGray-100
                        py-3
                        border-l-0
                        border-r-0
                        whitespace-nowrap
                        font-semibold
                        "
                    >
                      #
                    </td>
                    <td class="
                        px-2
                        bg-blueGray-50
                        text-blueGray-500
                        border border-solid
                        border-blueGray-100
                        py-3
                        border-l-0
                        border-r-0
                        whitespace-nowrap
                        font-semibold
                        "
                    >
                      Schuldenbetrag
                    </td>
                    <td class="
                        px-2
                        bg-blueGray-50
                        text-blueGray-500
                        border border-solid
                        border-blueGray-100
                        py-3
                        border-l-0
                        border-r-0
                        whitespace-nowrap
                        font-semibold
                        "
                    >
                      Monatliche Rate
                    </td>
                    <td class="
                        px-2
                        bg-blueGray-50
                        text-blueGray-500
                        border border-solid
                        border-blueGray-100
                        py-3
                        border-l-0
                        border-r-0
                        whitespace-nowrap
                        "
                    >
                      Endtermin
                    </td>
                    <td class="
                        px-2
                        bg-blueGray-50
                        text-blueGray-500
                        border border-solid
                        border-blueGray-100
                        py-3
                        border-l-0
                        border-r-0
                        whitespace-nowrap
                        font-semibold
                        "
                    >
                      Bank Name
                    </td>
                    <td class="
                        px-2
                        bg-blueGray-50
                        text-blueGray-500
                        border border-solid
                        border-blueGray-100
                        py-3
                        border-l-0
                        border-r-0
                        whitespace-nowrap
                        font-semibold
                        "
                    >
                      IBAN
                    </td>
                    <td class="
                        px-2
                        bg-blueGray-50
                        text-blueGray-500
                        border border-solid
                        border-blueGray-100
                        py-3
                        border-l-0
                        border-r-0
                        whitespace-nowrap
                        font-semibold
                        "
                    >
                      Soll abgelöst werden?
                    </td>
                  </tr>
                  <tr v-for="(client_credit, index) in form.client_credits" :key="client_credit.id">
                    <td class="
                        px-2
                        bg-blueGray-50
                        text-blueGray-500
                        border
                        border-solid
                        border-blueGray-100
                        py-3
                        border-l-0
                        border-r-0
                        whitespace-nowrap
                        font-semibold
                        "
                    >
                      {{ index + 1 }}
                    </td>
                    <td class="
                        px-2
                        bg-blueGray-50
                        text-blueGray-500
                        border
                        border-solid
                        border-blueGray-100
                        py-3
                        border-l-0
                        border-r-0
                        whitespace-nowrap
                        font-semibold
                        "
                    >
                      <text-input
                        v-model="client_credit.debt_amount"
                        class="w-full"
                      />
                    </td>

                    <td class="
                        px-2
                        bg-blueGray-50
                        text-blueGray-500
                        border
                        border-solid
                        border-blueGray-100
                        py-3
                        border-l-0
                        border-r-0
                        whitespace-nowrap
                        font-semibold
                        "
                    >
                      <text-input
                        v-model="client_credit.monthly_amount_rate"
                        class="w-full"
                      />
                    </td>

                    <td class="
                        px-2
                        bg-blueGray-50
                        text-blueGray-500
                        border
                        border-solid
                        border-blueGray-100
                        py-3
                        border-l-0
                        border-r-0
                        whitespace-nowrap
                        font-semibold
                        "
                    >
                      <text-input
                        v-model="client_credit.end_date"
                        class="w-full"
                      />
                    </td>

                    <td class="
                        px-2
                        bg-blueGray-50
                        text-blueGray-500
                        border
                        border-solid
                        border-blueGray-100
                        py-3
                        border-l-0
                        border-r-0
                        whitespace-nowrap
                        font-semibold
                        "
                    >
                      <text-input
                        v-model="client_credit.bank_name"
                        class="w-full"
                      />
                    </td>

                    <td class="
                        px-2
                        bg-blueGray-50
                        text-blueGray-500
                        border
                        border-solid
                        border-blueGray-100
                        py-3
                        border-l-0
                        border-r-0
                        whitespace-nowrap
                        font-semibold
                        "
                    >
                      <text-input
                        v-model="client_credit.iban_number"
                        class="w-full"
                      />
                    </td>

                    <td class="
                        px-2
                        bg-blueGray-50
                        text-blueGray-500
                        border
                        border-solid
                        border-blueGray-100
                        py-3
                        border-l-0
                        border-r-0
                        whitespace-nowrap
                        font-semibold
                    "
                    >
                      <select-input
                        v-model="client_credit.should_redeem"
                        class="w-full"
                      >
                        <option :key="1" :value="true">
                          Ja
                        </option>
                        <option :key="0" :value="false">
                          Nein
                        </option>
                      </select-input>
                    </td>
                  </tr>
                </table>
                <div>
                  <span
                    class="btn-green ml-auto"
                    @click="addCreditEntry()"
                  >
                    + Kredit hinzufügen
                  </span>
                </div>
              </div>
              <div v-show="selectedTab === 5" class="panel-3 tab-content py-5">
                <file-input
                  v-model="form.photo"
                  :error="form.errors.photo"
                  class="pr-6 pb-8 w-full "
                  type="file"
                  accept="image/*, application/pdf"
                  label="Datei"
                />
              </div>
              <div v-show="selectedTab === 6" class="panel-3 tab-content py-5">
                <div class="w-full mb-6">
                  <textarea-input
                    v-model="form.notes"
                    :error="form.errors.notes"
                    class="pr-6 pb-8 w-full"
                    label="Notizen"
                  />
                </div>
              </div>
            </div>
            <div v-show="selectedTab === 7" class="panel-3 tab-content py-5">
              <textarea-input
                v-model="form.note"
                :error="form.errors.note"
                class="pr-6 pb-8 w-full"
                label="Kundennotiz"
              />
              <text-input
                v-model="form.agreement_accepted_at"
                :error="form.errors.agreement_accepted_at"
                class="pr-6 pb-8 w-full"
                label="Vereinbarung angenommen um"
              />
              <h2 class="font-bold">
                Daten der 2. Person:
                <checkbox-input :value="hasSecondPerson" @input="hasSecondPerson = !hasSecondPerson" />
              </h2>
              <div v-if="hasSecondPerson" class="mt-2 p-2 pr-6 mb-6 w-full border">
                <div>
                  <text-input
                    v-model="form.second_person_data.first_name"
                    class="pb-8 w-full"
                    label="Vorname"
                  />
                </div>
                <div>
                  <text-input
                    v-model="form.second_person_data.last_name"
                    class="pb-8 w-full"
                    label="Nachname"
                  />
                </div>
                <div>
                  <text-input
                    v-model="form.second_person_data.gender"
                    class="pb-8 w-full"
                    label="Anrede"
                  />
                </div>
                <div>
                  <text-input
                    v-model="form.second_person_data.address"
                    class="pb-8 w-full"
                    label="Adresse"
                  />
                </div>
                <div>
                  <text-input
                    v-model="form.second_person_data.zip_code"
                    class="pb-8 w-full"
                    label="Postleitzahl"
                  />
                </div>
                <div>
                  <text-input
                    v-model="form.second_person_data.city"
                    class="pb-8 w-full"
                    label="Stadt"
                  />
                </div>
                <div>
                  <text-input
                    v-model="form.second_person_data.country"
                    class="pb-8 w-full"
                    label="Land"
                  />
                </div>
                <div>
                  <text-input
                    v-model="form.second_person_data.citizenship"
                    class="pb-8 w-full"
                    label="Staatsangehörigkeit"
                  />
                </div>
                <div>
                  <text-input
                    v-model="form.second_person_data.email"
                    class="pb-8 w-full"
                    label="Email"
                  />
                </div>
                <div>
                  <text-input
                    v-model="form.second_person_data.phone"
                    class="pb-8 w-full"
                    label="Telefon"
                  />
                </div>
                <div>
                  <text-input
                    v-model="form.second_person_data.date_of_birth"
                    class="pb-8 w-full"
                    label="Geburtsdatum"
                  />
                </div>
                <div>
                  <text-input
                    v-model="form.second_person_data.iban"
                    class="pb-8 w-full"
                    label="IBAN"
                  />
                </div>
              </div>
              <select-input
                v-model="form.status"
                :error="form.errors.status"
                class="pr-6 pt-4 pb-4 w-1/2"
                label="Status"
              >
                <option
                  v-for="(status, index) in Object.keys(form.statuses)"
                  :key="status"
                  :value="Object.keys(form.statuses)[index]"
                >
                  {{ form.statuses[status] }}
                </option>
              </select-input>
              <select-input
                v-model="form.source"
                :error="form.errors.source"
                class="pr-6 pt-4 pb-4 w-1/2"
                label="Source"
              >
                <option
                  v-for="(source, index) in Object.keys(form.sources)"
                  :key="source"
                  :value="Object.keys(form.sources)[index]"
                >
                  {{ form.sources[source] }}
                </option>
              </select-input>

              <select-input
                v-model="form.referral_code"
                :error="form.errors.referral_code"
                class="pr-6 pt-4 pb-4 w-1/2"
                label="Influencer"
              >
                <option :value="''">Kein Influencer</option>
                <option
                  v-for="influencer in influencers"
                  :key="influencer.id"
                  :value="influencer.influencer_code"
                >
                  {{ influencer.first_name }} {{ influencer.last_name }}
                </option>
              </select-input>

              <div v-if="form.referral_code" class="pr-6 pt-4 pb-4 w-full">
                <inertia-link
                  class="btn-green ml-auto"
                  :href="route('influencers.edit', form.referral_code)"
                >
                  Öffne Influencer
                </inertia-link>
              </div>
            </div>
            <div v-show="selectedTab === 8" class="panel-3 tab-content py-5">
              <h3 class="font-semibold pb-4">Finanzierungswunsch</h3>
              <select-input
                v-model="form.property_type"
                :error="form.errors.property_type"
                class="pr-6 pb-8 w-full"
                label="Immobilienart"
              >
                <option value="ETW">Etagenwohnung</option>
                <option value="EFH">Einfamilienhaus</option>
                <option value="ZFH">Zweifamilienhaus</option>
                <option value="MFH">Mehrfamilienhaus</option>
                <option value="Bauvorhaben">Bauvorhaben</option>
              </select-input>
              <select-input
                v-model="form.financing_wish"
                :error="form.errors.financing_wish"
                class="pr-6 pb-8 w-full"
                label="Finanzierungswunsch"
              >
                <option value="Kaufvorhaben">Kauffinanzierung</option>
                <option value="Anschlussfinanzierung">Anschlussfinanzierung</option>
                <option value="Modernisierung">Modernisierung</option>
                <option value="Kapitalbeschaffung">Kapitalbeschaffung</option>
              </select-input>
              <text-input
                v-model="form.purchase_price"
                :error="form.errors.purchase_price"
                class="pr-6 pb-8 w-full"
                label="Kaufpreis bzw. Kosten (ohne Nebenkosten)"
              />
              <text-input
                v-model="form.equity"
                :error="form.errors.equity"
                class="pr-6 pb-8 w-full"
                label="Eigenkapital, falls vorhanden"
              />
              <select-input
                v-model="form.subsidies"
                :error="form.errors.subsidies"
                class="pr-6 pb-8 w-full"
                label="Fördermittel?"
              >
                <option value="Bau oder Modernisierung">KfW 261</option>
                <option value="Eigennutzer">KfW 124</option>
                <option value="WfA Mittel">NRW.Bank | WfA</option>
                <option value="Weiß ich nicht">Weiß ich nicht</option>
              </select-input>

              <h3 class="font-semibold pb-4 pt-4">Kaufimmobilie</h3>
              <text-input
                v-model="form.property_zip_code"
                :error="form.errors.property_zip_code"
                class="pr-6 pb-8 w-full"
                label="Adresse (PLZ) der Immobilie"
              />
              <text-input
                v-model="form.living_area"
                :error="form.errors.living_area"
                class="pr-6 pb-8 w-full"
                label="Wohnfläche (m²)"
              />

              <h3 class="font-semibold pb-4 pt-4">Person 1</h3>
              <div class="flex">
                <text-input
                  v-model="form.first_name"
                  :error="form.errors.first_name"
                  class="pr-6 pb-8 w-1/2"
                  label="Vorname"
                />
                <text-input
                  v-model="form.last_name"
                  :error="form.errors.last_name"
                  class="pr-6 pb-8 w-1/2"
                  label="Nachname"
                />
              </div>
              <text-input
                v-model="form.phone"
                :error="form.errors.phone"
                class="pr-6 pb-8 w-full"
                label="Telefon"
              />
              <text-input
                v-model="form.address"
                :error="form.errors.address"
                class="pr-6 pb-8 w-full"
                label="Adresse (Straße, Nr.)"
              />
              <text-input
                v-model="form.date_of_birth"
                :error="form.errors.date_of_birth"
                class="pr-6 pb-8 w-full"
                label="Geburtstag"
              />
              <text-input
                v-model="form.family_status"
                :error="form.errors.family_status"
                class="pr-6 pb-8 w-full"
                label="Familienstand"
              />
              <text-input
                v-model="form.email"
                :error="form.errors.email"
                class="pr-6 pb-8 w-full"
                label="E-Mail-Adresse"
              />
              <text-input
                v-model="form.zip_code"
                :error="form.errors.zip_code"
                class="pr-6 pb-8 w-full"
                label="Adresse (PLZ)"
              />
              <text-input
                v-model="form.number_of_kids_with_benefit"
                :error="form.errors.number_of_kids_with_benefit"
                class="pr-6 pb-8 w-full"
                label="Kinder im Haushalt"
              />
              <text-input
                v-model="form.occupation"
                :error="form.errors.occupation"
                class="pr-6 pb-8 w-full"
                label="Beruf"
              />
              <text-input
                v-model="form.average_monthly_income"
                :error="form.errors.average_monthly_income"
                class="pr-6 pb-8 w-full"
                label="mtl. Nettogehalt"
              />
              <text-input
                v-model="form.started_working_at"
                :error="form.errors.started_working_at"
                class="pr-6 pb-8 w-full"
                label="Beschäftigungsbeginn"
              />
              <text-input
                v-model="form.rent_amount"
                :error="form.errors.rent_amount"
                class="pr-6 pb-8 w-full"
                label="ggf. Miete"
              />
              <text-input
                v-model="form.current_credit_rates"
                :error="form.errors.current_credit_rates"
                class="pr-6 pb-8 w-full"
                label="lfd. Kreditraten (mtl.)"
              />

              <h3 class="font-semibold pb-4 pt-4">2. Person</h3>
              <div class="flex">
                <text-input
                  v-model="form.second_person_data.first_name"
                  class="pr-6 pb-8 w-1/2"
                  label="Vorname"
                />
                <text-input
                  v-model="form.second_person_data.last_name"
                  class="pr-6 pb-8 w-1/2"
                  label="Nachname"
                />
              </div>
              <text-input
                v-model="form.second_person_data.family_status"
                class="pr-6 pb-8 w-full"
                label="Familienstand"
              />
              <text-input
                v-model="form.second_person_data.date_of_birth"
                class="pr-6 pb-8 w-full"
                label="Geburtsdatum"
              />
              <text-input
                v-model="form.second_person_data.income"
                class="pr-6 pb-8 w-full"
                label="Einkommen (mtl.)"
              />
              <text-input
                v-model="form.second_person_data.credit_rates"
                class="pr-6 pb-8 w-full"
                label="lfd. Kreditraten (mtl.)"
              />

              <h3 class="font-semibold pb-4 pt-4">Zusatzinformationen</h3>
              <text-input
                v-model="form.additional_info"
                :error="form.errors.additional_info"
                class="pr-6 pb-8 w-full"
                label="Zusatzinformationen"
              />
            </div>
          </div>
        </div>

        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <InertiaLink
            class="text-red-600 hover:underline"
            tabindex="-1"
            type="button"
            :href="route('clients')"
          >
            Zurück
          </InertiaLink>
          <loading-button
            :loading="form.processing"
            class="btn-green ml-auto"
            type="submit"
          >
            Speichern
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '../../Shared/SelectInput'
import statuses from './statuses'
import sources from './sources'
import TextareaInput from '../../Shared/TextareaInput'
import CheckboxInput from '../../Shared/CheckboxInput.vue'

export default {
  metaInfo() {
    return {
      title: 'Erschaffe Kunde',
    }
  },
  components: {
    CheckboxInput,
    TextareaInput,
    SelectInput,
    FileInput,
    LoadingButton,
    TextInput,
  },
  layout: Layout,
  props: {
    users: Array,
    influencers: Array,
  },
  remember: 'form',
  data() {

    const tabs = [
      'Basisinformation',
      'Beruf',
      'Finanzdaten',
      'Kredit',
      'Bestehende Kredite',
      'Datei',
      'Notizen',
      'Andere',
      'Immobilienkredit',
    ]
    const selectedTab = 0

    return {
      baseCreditOptions: {
        'Abs. bei Todesfall': 0, 'Abs. bei AU': 0, 'Abs. bei AL': 0,
      },
      caseOfDeath: false,
      caseOfUnemployability: false,
      caseOfLoosingJob: false,
      hasSecondPerson: false,
      form: this.$inertia.form({
        _method: 'post',
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        address: '',
        lives_here_from: '',
        zip_code: '',
        city: '',
        country: '',
        citizenship: '',
        place_of_birth: '',
        gender: '',
        date_of_birth: '',
        family_status: '',
        work_permit_type: '',
        number_of_kids_with_benefit: '',
        occupation: '',
        company: '',
        started_working_at: '',
        employment_type: '',
        is_probation_period: '',
        probation_period_until: '',
        number_of_salaries: '',
        average_monthly_income: '',
        other_income: '',
        other_income_source: '',
        number_of_credits: '',
        has_rent: '',
        rent_amount: '',
        has_furniture_expenses: '',
        furniture_expenses_rate: '',
        has_leasing: '',
        leasing_rate: '',
        has_maintenance: '',
        iban: '',
        note: '',
        agreement_accepted_at: '',
        credit_purpose: '',
        wanted_credit_amount: '',
        period: '',
        credit_securing: this.creditSecuringString,
        status: Object.keys(statuses)[0],
        photo: null,
        deleted_at: null,
        referential_url: '',
        statuses: statuses,
        deleted_files: [],
        user: '',
        notes: '',
        source: Object.keys(sources)[Object.keys(sources).length - 1],
        sources: sources,
        referral_code: '',
        client_credits: [],
        second_person_data: {
          first_name: '',
          last_name: '',
          email: '',
          phone: '',
          address: '',
          zip_code: '',
          city: '',
          country: '',
          citizenship: '',
          date_of_birth: '',
          iban: '',
          family_status: '',
          income: '',
          credit_rates: '',
        },
        user_id: null,
        type: null,
        property_type: null,
        financing_wish: null,
        purchase_price: null,
        equity: null,
        subsidies: null,
        property_zip_code: null,
        living_area: null,
        additional_info: null,
        current_credit_rates: null,
      }),
      statuses,
      sources,
      tabs,
      selectedTab,
    }
  },
  methods: {
    handleSecuring(type) {
      this.baseCreditOptions[type] = this.baseCreditOptions[type] === 0 ? 1 : 0
    },
    addCreditEntry() {
      this.form.client_credits.push({
        debt_amount: '',
        monthly_amount_rate: '',
        end_date: '',
        bank_name: '',
        iban_number: '',
        should_redeem: false,
      })
    },
    removeImage(id) {
      if (this.form.deleted_files.indexOf(id) === -1) {
        this.form.deleted_files.push(id)
      }
    },
    update() {
      this.form.credit_securing = `Abs. bei Todesfall: ${this.caseOfDeath ? '1' : '0'} | Abs. bei AU: ${this.caseOfUnemployability ? '1' : '0'} | Abs. bei AL: ${this.caseOfLoosingJob ? '1' : '0'}`
      this.form.post(this.route('clients.store').url(), {
        onSuccess: () => {
          this.form.reset()
          this.form.deleted_files = []
        },
      })
    },
    showTab(index){
      this.selectedTab = index
    },
  },
}
</script>
<style scoped>
.active-tab {
    border-bottom: 2px solid #56baa2;
}
</style>
